<template>
  <div class="invalid-address-warning">
    <!-- Error state with Use Anyway button -->
    <Alert v-if="!usedAnyway" type="error" :show-icon="true">
      <div class="flex items-center justify-between w-full">
        <span>{{ warningText }}</span>
        <Button
          v-if="showUseAnywayButton"
          color-type="red"
          type="narrow"
          @click="handleUseAnyway"
        >
          Use Anyway
        </Button>
      </div>
    </Alert>

    <!-- Warning state with close button -->
    <Alert v-else type="warning" :show-icon="true">
      <div class="flex items-center justify-between w-full">
        <span>The address entered above is invalid.</span>
        <button class="close-button" @click="$emit('close')">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </Alert>
  </div>
</template>

<script>
import Alert from '@/NewLibrary/Alert.vue';
import Button from '@/NewLibrary/Button.vue';

export default {
  name: 'InvalidAddressWarning',
  components: {
    Alert,
    Button,
  },
  props: {
    warningText: {
      type: String,
      default: 'The address entered above is invalid.',
    },
    showUseAnywayButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['use-anyway', 'close', 'acknowledged'],
  data() {
    return {
      usedAnyway: false,
    };
  },
  methods: {
    handleUseAnyway() {
      this.usedAnyway = true;
      // Emit acknowledged event to remove red border
      this.$emit('acknowledged');
    },
  },
};
</script>

<style scoped>
.invalid-address-warning {
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.close-button:hover {
  opacity: 1;
}
</style>
